import React, { useState } from "react";
import axios from "axios";
import { Table, Tooltip, Button, Modal, message, Drawer } from "antd";

import { formatDateTime } from "../../helpers/date";

import ServiceProviderTag from "../shared/ServiceProviderTag";
import { InfoCircleOutlined } from "@ant-design/icons";

const PickupRequestList = ({ pickupRequest, loading }) => {
  const [selectedPickup, setSelectedPickup] = useState(null);

  const table = [
    {
      title: "Pickup Id",
      dataIndex: "id",
      width: 120,
    },
    {
      title: "Courier",
      dataIndex: ["pickupInfo", "serviceProvider"],
      width: 120,
      render: (text) =>
        text ? <ServiceProviderTag serviceProviderKey={text} /> : "",
    },
    {
      title: "Collection Ref Id",
      dataIndex: ["pickupInfo", "collectionRefId"],
      width: 150,
      render: (text) => (text ? text : "-"),
    },
    {
      title: "Pickup Contact",
      dataIndex: ["pickupAddress"],
      width: 230,
      render: (address) => {
        return (
          <>
            {address?.name || "-"}
            <br />({address?.phone || "-"})
            {address?.email && (
              <>
                <br />({address?.email})
              </>
            )}
          </>
        );
      },
    },
    {
      title: "Pickup Address",
      dataIndex: ["pickupAddress"],
      render: (address) => {
        if (!address) return "-";

        const {
          line1 = "",
          line2 = "",
          postcode = "",
          state = "",
          country = "",
        } = address;

        const formattedAddress = [line1, line2, postcode, state, country]
          .filter((part) => part)
          .join(", ");

        return formattedAddress || "-";
      },
    },
    {
      title: "Orders",
      dataIndex: ["parcelQuantity"],
      width: 100,
      render: (parcelQuantity, pickupRequest) => {
        return (
          <>
            {parcelQuantity}
            {` `}
            <Tooltip placement="topLeft" title="More info" className="mr-2">
              <InfoCircleOutlined
                onClick={() => setSelectedPickup(pickupRequest)}
              />
            </Tooltip>
          </>
        );
      },
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      width: 150,
      render: (text) => (text ? formatDateTime(text) : "-"),
    },
    {
      title: "Action",
      dataIndex: ["pickupInfo", "serviceProvider"],
      align: "center",
      width: 120,
      render: (text, record) =>
        text === "aramex" && !record.cancelled ? (
          <Button type="primary" onClick={() => cancelPickup(record)}>
            Cancel
          </Button>
        ) : record.cancelled ? (
          "Cancelled"
        ) : (
          "-"
        ),
    },
  ];

  const cancelPickup = async (pickup) => {
    console.log(pickup);
    try {
      const confirmationMessage = (
        <div>
          <p className="marginBottom-20">
            Pickup Id : <strong>{pickup.id}</strong>
          </p>
        </div>
      );

      Modal.confirm({
        content: confirmationMessage,
        title: `Confirm to cancel the pickup request ?`,
        width: 800,
        async onOk() {
          await axios
            .post("api/riderInfo/cancel", {
              id: pickup.id,
            })
            .then((res) => {
              message.info(
                `Order (${pickup.orderInfo.consign_no}) has been marked as Cancelled By User.`
              );
            })
            .catch((error) => {
              message.error(error.response.data.message || error.message);
            });
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="table">
      <Table
        rowKey="objectId"
        className="table-section"
        columns={table}
        dataSource={pickupRequest}
        pagination={false}
        scroll={{ x: 1400, y: 600  }}
        loading={loading}
      />

      {selectedPickup && (
        <Drawer
          width={736}
          title="Pickup Request Orders"
          closable={{ "aria-label": "Close Button" }}
          onClose={() => setSelectedPickup(null)}
          visible={selectedPickup}
        >
          {selectedPickup.ordersSummary?.length && (
            <ol>
              {selectedPickup.ordersSummary.map((order) => (
                <li>
                  {order.trackingNo}: {order.status} ({order.internalStatus})
                </li>
              ))}
            </ol>
          )}

          {selectedPickup.orderInfo?.consign_no && (
            <ol>
              <li>
                {selectedPickup.orderInfo?.consign_no}:{" "}
                {selectedPickup.orderInfo?.status} (
                {selectedPickup.orderInfo?.internalStatus})
              </li>
            </ol>
          )}
        </Drawer>
      )}
    </div>
  );
};

export default PickupRequestList;
